import { render, staticRenderFns } from "./BriefIcon.vue?vue&type=template&id=e37d240a&scoped=true"
import script from "./BriefIcon.vue?vue&type=script&lang=js"
export * from "./BriefIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37d240a",
  null
  
)

export default component.exports